import keys from 'lodash/keys';
import pick from 'lodash/pick';
import without from 'lodash/without';
import isArray from 'lodash/isArray';
import pickBy from 'lodash/pickBy';
import startCase from 'lodash/startCase';
import { DEFAULT_FILTERS } from 'lib/enums/search';

const getMinStarRatingTitle = (minStarRating) => `${minStarRating} stars${minStarRating < 5 ? ' & up' : ''}`;
const getMinTripadvisorRatingTitle = (minTripadvisorRating) => {
  if (minTripadvisorRating === '5') {
    return 'Excellent 5.0';
  } else if (minTripadvisorRating === '4') {
    return 'Very good 4.0+';
  } else {
    return 'Average 3.0+';
  }
};

const getFilterTitle = (filterType, filterValue) => {
  if (filterType === 'minStarRating') {
    return getMinStarRatingTitle(filterValue);
  } else if (filterType === 'minTripadvisorRating') {
    return getMinTripadvisorRatingTitle(filterValue);
  } else {
    return startCase(filterType);
  }
};

export const getActiveNonPriceFilterProps = (query) => {
  const filters = pick(query, keys(DEFAULT_FILTERS));
  // eslint-disable-next-line no-unused-vars
  const { minPrice, maxPrice, subRegions, ...nonPriceFilters } = filters;
  const activeFiltersProps = keys(pickBy(nonPriceFilters))
    .map((filterType) => {
      const filterValue = filters[filterType];
      if (isArray(filterValue)) {
        return filterValue.map((subFilter) => ({
          id: subFilter,
          title: startCase(subFilter),
          filterType: filterType,
          filterValue: without(filterValue, subFilter),
        }));
      } else {
        return {
          id: filterType,
          title: getFilterTitle(filterType, filterValue),
          filterType: filterType,
        };
      }
    })
    .flat();
  return activeFiltersProps;
};
